import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import NoteList from "./NoteList";
import { useQuery, useMutation } from "@apollo/react-hooks";
import auth from "../../../../providers/Auth.Provider";
import { GET_NOTES, NEW_NOTE, UPDATE_NOTE, CONFIRM, INVALIDATE_NOTE, REMOVE_NOTE } from "../../../../queries/note.query";
import LoadingSpinner from "../../../../partials/loading";
import Pagination from "../../../../partials/pagination";
import NewNoteForm from "./NewNote";
import UpdateNoteForm from "./UpdateNote";
import InvalidateNoteForm from "./InvalidateNote";
import NoteDetail from "./Detail.jsx";
import InsertManyNote from "./InsertMany.jsx";
import { ReadData } from "../../../../providers/Patient.Provider.js";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import { sendNotification } from "../../../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../../../event/model";
import { EventEmitter } from "../../../../event/EventEmitter";

const PatientPlanNote = ({ location, match }) => {
    const [newNote, setNewNote] = useState(false);
    const [page] = useState(1);
    const [limit] = useState(25);
    const [note, setNote] = useState(null);
    const [iNote, setINote] = useState(null);
    const [vNote, setVNote] = useState(null);
    const [isMulti, setMulti] = useState(false);

    // patient
    const patient = ReadData();

    // update
    const { id } = match.params;
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();

    // List query
    const { loading, data, fetchMore, refetch } = useQuery(GET_NOTES, {
        variables: { id, site: site && site.id, page, limit },
        notifyOnNetworkStatusChange: true,
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    // New Note
    const [NewNoteFunc, { loading: nLoading }] = useMutation(NEW_NOTE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.NewNote) {
                const { message, doc } = d.NewNote;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.CREATE, EVENT_TARGET.CARE_NOTE);
                setNewNote(false);
                setVNote(false);
                setNote(null);
                setINote(null);
                scrollTop();
                setMulti(false);
            }
        },
    });

    const [RemoveNoteFunc, { loading: rLoading }] = useMutation(REMOVE_NOTE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.DeleteClinicalNote) {
                const { message, doc } = d.DeleteClinicalNote;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.DELETE, EVENT_TARGET.CARE_NOTE);
            }
        },
    });

    // Update
    const [updateNoteFunc, { loading: uLoading }] = useMutation(UPDATE_NOTE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.UpdateNote) {
                const { message, doc } = d.UpdateNote;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.CARE_NOTE);
                setNewNote(false);
                setVNote(false);
                setNote(null);
                setINote(null);
                scrollTop();
            }
        },
    });

    // Confirm
    const [confirmNoteFunc, { loading: cLoading }] = useMutation(CONFIRM, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.ConfirmClinicalNote) {
                const { message, doc } = d.ConfirmClinicalNote;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.CARE_NOTE);
            }
        },
    });

    // Confirm
    const [invalidateNoteFunc, { loading: iLoading }] = useMutation(INVALIDATE_NOTE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.InvalidateClinicalNote) {
                const { message, doc } = d.InvalidateClinicalNote;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.CARE_NOTE);
            }
        },
    });

    const title = "Care note";

    if (patient && !patient.lastAdmission)
        return (
            <>
                <div className="text-center">
                    <h2 className="text-pink">Feature can only be used for in-patient only!</h2>
                </div>
            </>
        );
    EventEmitter.subscribe(EVENT_TARGET.CARE_NOTE, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            {vNote && !newNote && !note && (
                <div className="row justify-content-center fade-in">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewNote(false);
                                            setVNote(false);
                                            setNote(null);
                                            setINote(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>{" "}
                                    </button>
                                    Back
                                </header>
                            </div>
                            <div className="card-body">
                                <NoteDetail item={vNote} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!vNote && (
                <div className="row justify-content-center fade-in">
                    {!vNote && newNote && !note && !isMulti && (
                        <div className="col-md-12 m-b-20 fade-in">
                            <div className="card">
                                <div className="card-head">
                                    <header>
                                        <button
                                            onClick={() => {
                                                setNewNote(false);
                                                setVNote(false);
                                                setNote(null);
                                                setINote(null);
                                                scrollTop();
                                            }}
                                            title="Back"
                                            className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                        >
                                            <i className="material-icons text-primary">keyboard_backspace</i>
                                        </button>
                                        Back
                                    </header>
                                </div>
                                <div className="card-head">
                                    <header>New Care Note</header>
                                </div>
                                <div className="card-body">
                                    <LoadingSpinner loading={nLoading} />
                                    <NewNoteForm
                                        onCancel={() => {
                                            setNewNote(false);
                                            setVNote(false);
                                            setNote(null);
                                            setINote(null);
                                            scrollTop();
                                        }}
                                        categories={data && data.GetCareNoteCategories.docs}
                                        onSubmit={async (item) => {
                                            scrollTop();
                                            const { confirm, ...rest } = item;
                                            await NewNoteFunc({
                                                variables: {
                                                    model: {
                                                        ...rest,
                                                        patient: id,
                                                        admission: patient.lastAdmission,
                                                    },
                                                    confirm,
                                                },
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {!vNote && newNote && !note && isMulti && (
                        <div className="col-md-12 m-b-20 fade-in">
                            <LoadingSpinner loading={nLoading} />
                            <InsertManyNote
                                onCancel={() => {
                                    setNewNote(false);
                                    setVNote(false);
                                    setNote(null);
                                    setINote(null);
                                    scrollTop();
                                }}
                                categories={data && data.GetCareNoteCategories.docs}
                                onSubmit={async (item) => {
                                    scrollTop();
                                    const { confirm, ...rest } = item;
                                    await NewNoteFunc({
                                        variables: {
                                            model: {
                                                ...rest,
                                                patient: id,
                                                admission: patient.lastAdmission,
                                            },
                                            confirm,
                                        },
                                    });
                                }}
                            />
                        </div>
                    )}

                    {note && !vNote && !iNote && !newNote && (
                        <div className="col-md-12 fade-in">
                            <div className="card">
                                <div className="card-head">
                                    <header>Update {note.notes[0].summary}</header>
                                </div>
                                <div className="card-body m-b-20">
                                    <LoadingSpinner loading={uLoading} />
                                    <UpdateNoteForm
                                        onCancel={() => {
                                            setNewNote(false);
                                            setVNote(false);
                                            setNote(null);
                                            setINote(null);
                                            scrollTop();
                                        }}
                                        onSubmit={async (update) => {
                                            await updateNoteFunc({
                                                variables: {
                                                    id: note.id,
                                                    update,
                                                },
                                            });
                                        }}
                                        item={note}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {iNote && !note && !newNote && !vNote && (
                        <div className="col-md-12 fade-in">
                            <div className="card">
                                <div className="card-head">
                                    <header>
                                        <span className="text-muted">Invalidate: </span> {iNote.summary}
                                    </header>
                                </div>
                                <div className="card-body m-b-20">
                                    <LoadingSpinner loading={iLoading} />
                                    <InvalidateNoteForm
                                        onCancel={() => {
                                            setNewNote(false);
                                            setVNote(false);
                                            setNote(null);
                                            setINote(null);
                                            scrollTop();
                                        }}
                                        onSubmit={async ({ reason }) => {
                                            await invalidateNoteFunc({
                                                variables: {
                                                    reason,
                                                    id: iNote.id,
                                                },
                                            });
                                            setNewNote(false);
                                            setVNote(false);
                                            setNote(null);
                                            setINote(null);
                                            scrollTop();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {!note && !vNote && !newNote && !iNote && (
                        <div className="col-md-12 m-b-20 fade-in">
                            <div className="card">
                                <div className="card-head">
                                    <header>Care Notes</header>
                                    <div className="float-right mt-2 mr-5">
                                        <button
                                            onClick={() => {
                                                setNewNote(true);
                                                setMulti(false);
                                                scrollTop();
                                            }}
                                            className="mdl-button mdl-button--raised btn-circle margin-right-10"
                                            type="button"
                                        >
                                            <i className="material-icons text-primary">add</i> Single Note
                                        </button>
                                        <button
                                            onClick={() => {
                                                setNewNote(true);
                                                setMulti(true);
                                                scrollTop();
                                            }}
                                            className="mdl-button mdl-button--raised btn-circle"
                                        >
                                            Multiple Note <i className="material-icons text-primary">add</i>
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body" style={{ minHeight: "420px" }}>
                                    <LoadingSpinner loading={loading || cLoading || rLoading} />
                                    {!loading && (
                                        <NoteList
                                            items={data && data.GetClinicalNotesOfPatient.docs}
                                            onEdit={(note) => {
                                                setNewNote(false);
                                                setVNote(false);
                                                setNote(note);
                                                setINote(null);
                                                scrollTop();
                                            }}
                                            onConfirm={async (item) => {
                                                await confirmNoteFunc({
                                                    variables: { id: item.id },
                                                });
                                            }}
                                            inValidate={(item) => {
                                                setNewNote(false);
                                                setVNote(false);
                                                setNote(null);
                                                setINote(item);
                                                scrollTop();
                                            }}
                                            onView={(item) => setVNote(item)}
                                            onRemove={async (i) => {
                                                await RemoveNoteFunc({
                                                    variables: { id: i.id },
                                                });
                                            }}
                                        />
                                    )}
                                </div>
                                {data && (
                                    <Pagination
                                        length={data.GetClinicalNotesOfPatient.docs.length}
                                        {...data.GetClinicalNotesOfPatient}
                                        onPageClicked={(page) =>
                                            fetchMore({
                                                variables: { page },
                                                updateQuery: (prev, { fetchMoreResult }) => {
                                                    if (!fetchMoreResult) return prev;
                                                    return {
                                                        GetClinicalNotesOfPatient: fetchMoreResult.GetClinicalNotesOfPatient,
                                                    };
                                                },
                                            })
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default PatientPlanNote;
